import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';
import { CoreModule } from '@ddt-web/data-layer-components';
import { DataServiceModule } from '@ddt-web/data-service';
import { HeaderModule } from '@ddt-web/navigation';
import { PerformanceModule } from '@ddt-web/performance';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

import { FamilyFooterModule } from '../family-footer/family-footer.module';
import { RedirectCtaModule } from '../redirect-cta';
import { FundPerformanceFeesComponent } from './fund-performance-fees.component';

@NgModule({
	imports: [
		CommonModule,
		RouterModule.forChild([
			{ path: '', component: FundPerformanceFeesComponent }
		]),
		CwpNgFrameworkModule,
		HeaderModule,
		DataServiceModule,
		PerformanceModule,
		CoreModule,
		NgxSkeletonLoaderModule,
		FamilyFooterModule,
		RedirectCtaModule
	],
	declarations: [
		FundPerformanceFeesComponent
	]
})
export class FundPerformanceFeesModule { }
